import React from 'react'
import AppHeaderLinks from "./AppHeaderLinks"
import { navigateService } from '../../services/navigate.service'
import { useNavigate } from 'react-router-dom'
import { routeService } from '../../services/route.service'

export function DesktopAppHeader() {
    const navigate = useNavigate()

    function handleGoToHomePage() {
        navigateService.handleNavigation(navigate, routeService.HOME)
    }

    return (
        <div className="flex items-center justify-between bg-white px-5 py-[10px] border border-[#EFF0F6] shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
            <div className="flex items-center cursor-pointer" onClick={handleGoToHomePage}>
                <img
                    src="https://haatdaas.lan-wan.net/daas/images/logo.svg"
                    alt="Company Logo"
                    className="h-12"
                />
            </div>
            <nav className="flex gap-4">
                <AppHeaderLinks />
            </nav>
        </div>
    )
}
